/**
 * @description 埋点组件类型定义 - 集中配置管理方案
 * @author zcq
 * @date 2025-04-18
 */

// 埋点类型枚举
export enum ETrackingType {
  PAGE_VIEW = 'page_view',
  CLICK = 'click',
  FORM_SUBMIT = 'form_submit',
  API = 'api',
  ERROR = 'error',
  PERFORMANCE = 'performance',
  CUSTOM = 'custom',
}

// 埋点框架类型枚举
export enum EBurialFramework {
  ARMS = 'arms',
  FIREBASE = 'firebase',
  MIXPANEL = 'mixpanel',
}

export enum EBaseEnv {
  DEV = 'dev',
  TEST = 'test',
  PROD = 'prod',
}

// 区域枚举
export enum ERegion {
  US = 'us',
  EU = 'eu',
  NA = 'na',
}

export enum ELane {
  AIO = 'aio',
  FEAT = 'feat',
  UAT = 'uat',
}

// 环境枚举 - write by cursor
export type EEnvironment = EBaseEnv | ERegion | ELane;

// 平台枚举 - write by cursor
export enum EPlatform {
  IAM = 'iam',
  ROBOT_CLOUD = 'robot-cloud',
  DEVELOPER = 'developer',
  OPEN_PLATFORM = 'open-platform',
  MFA_SSO = 'mfa-sso',
  PARAMETER_FLOW_MANAGEMENT = 'parameter-flow-management',
  PROPERTY_MANAGEMENT = 'property-management',
  OTA_MANAGEMENT = 'ota-management',
  OPERATION_MAINTENANCE = 'operation-maintenance',
  APPLICATION_CENTER = 'application-center',
  APPS_MOBILE = 'apps-mobile',
  AUDIT_CENTER = 'audit-center',
  PARTNER = 'partner',
}


// write by cursor
/**
 * 埋点策略接口
 */
export interface IBurialPointStrategy {
  init(): Promise<void>;
  sendEvent(eventType: string, eventName: string, params?: Record<string, any>): void;
  startTrace?(traceName: string): void;
  stopTrace?(traceName: string): void;
}

// write by cursor
/**
 * 策略配置接口
 */
export type IStrategyConfig = Record<string, any>;

// write by cursor
/**
 * 事件队列项
 */
export interface IQueuedEvent {
  type: 'pageView' | 'event' | 'startTrace' | 'stopTrace';
  args: any[];
}

// 全局类型声明
declare global {
  interface Window {
    __rum: any;
    RumSDK: any;
    mixpanel: any;
  }
}
